/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_Metric_HelpInputs */

const en_ui_settings_metric_help = /** @type {(inputs: Ui_Settings_Metric_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show metric explanations`)
};

const de_ui_settings_metric_help = /** @type {(inputs: Ui_Settings_Metric_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrik-Erklärungen anzeigen`)
};

/**
* | output |
* | --- |
* | "Show metric explanations" |
*
* @param {Ui_Settings_Metric_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_metric_help = /** @type {((inputs?: Ui_Settings_Metric_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_Metric_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_metric_help(inputs)
	return de_ui_settings_metric_help(inputs)
});